import Vue from 'vue'
import '@babel/polyfill'
import App from './App.vue'
import router from './router'
import createPersistedState from 'vuex-persistedstate'
import store from './store'
import GlobalMixin from '@/mixins/global'
import request from '@/common/ability/request'
import ztree from '../public/zTree/js/jquery.ztree.all'
import echarts from 'echarts'
import 'jquery'

import Antd from 'ant-design-vue'
import StandardTable from '@/components/table/StandardTable'
import StandardForm from '@/components/form/StandardForm'
import 'ant-design-vue/dist/antd.less'
import '@/common/style/reset.less'
import '@/common/style/common.less'
import'../public/zTree/css/zTreeStyle/zTreeStyle.css'

Vue.prototype.$axios = request
Vue.prototype.$echarts = echarts
Vue.use(Antd)
Vue.component('StandardTable', StandardTable)
Vue.component('StandardForm', StandardForm)
Vue.mixin(GlobalMixin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
